import { render, staticRenderFns } from "./ManageVersionsDialog.vue?vue&type=template&id=681aeeaa&scoped=true"
import script from "./ManageVersionsDialog.vue?vue&type=script&lang=js"
export * from "./ManageVersionsDialog.vue?vue&type=script&lang=js"
import style0 from "./ManageVersionsDialog.vue?vue&type=style&index=0&id=681aeeaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681aeeaa",
  null
  
)

export default component.exports